<h1 class="mobile-page-main-title flex pb-6 items-center">
  @if (callbackButton()) {
    <mat-icon
      class="text-4xl mr-3 ml-[-9px]"
      (click)="buttonCallback.emit()"
      fontIcon="chevron_left"
      matPrefix
    />
  } @else {
    <mat-icon
      class="text-4xl mr-3 ml-[-9px]"
      [directLink]="directLink()"
      [simpleBackLink]="simpleBackLink()"
      appBackButton
      fontIcon="chevron_left"
      matPrefix
    />
  }

  @if (backHomeLink()) {
    <i
      class="icon-dashboard-stroke text-3xl pr-4"
      routerLink="/dashboard"
    ></i>
  }

  <div>
    @if (titleName()) {
      <div class="text-base font-medium text-ui-gray-100 pb-0">
        {{ titleName() }}
      </div>
    }
    <div class="leading-none">{{ title() }}</div>
  </div>
</h1>
